<template>
  <v-container fluid>
    <router-view />
  </v-container>
</template>

<script>
export default {
  name: "LayoutCustomers",
};
</script>

<style scoped></style>
